module.exports = __webpack_public_path__ + "img/dy.33cb01da.svg";